import { io, Socket } from "socket.io-client";
import { HOST_API } from "../config";


let socket: Socket | null = null;
let accessToken = '';
let lastSentAccessToken = '';

async function init() {
  if (socket !== null) {
    return;
  }

  console.log("websocket init");

  socket = io(HOST_API, { path: '/api/socket.io', transports: ["websocket"] });

  await new Promise((resolve, reject) => {
    socket!.on("connect", () => {
      console.log("socket.id=" + socket!.id);

      if (accessToken !== '') {
        setAccessToken(accessToken);
      }

      resolve(1);
    });
  });

  socket!.on("disconnect", () => {
    lastSentAccessToken = '';
    console.log("socket.disconnect");
  });
}

async function getSocket() {
  if (socket !== null) {
    return socket;
  }

  await init();

  return socket;
}

async function emit(event: string, message: string) {
  let s = await getSocket();

  if (s !== null) {
    s.emit(event, message);
  }
}

async function setAccessToken(token: string) {
  accessToken = token;
  if (accessToken !== lastSentAccessToken) {
    await emit('access_token', accessToken);
  }
  lastSentAccessToken = accessToken;
}

const exportedObject = { init, getSocket, emit, setAccessToken };

export default exportedObject;